import { render } from "./ArrowHint.vue?vue&type=template&id=7af66a54"
import script from "./ArrowHint.vue?vue&type=script&lang=js"
export * from "./ArrowHint.vue?vue&type=script&lang=js"
script.render = render

export default script